// Section 16: Founders first norm. Established by rationing newcomers short while founders are fed
// (4 uses in a row; reset when founders go short); lost after 8 seasons without reinforcement.
// Effect once established: newcomer trust starts at 25 (migration stream, on admission); arrival
// events are drawn at 0.5x (the eventWeight of config.norms['founders-first'].arrivalEvents).
// Constants: config.normRules, config.norms['founders-first'].
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { foodPrecedent, ranksBefore, wentShort } from '../../core/content-helpers';
import { defineNorm } from '../../core/registry';

export function foundersFirst(config: Config) {
  const c = config.norms['founders-first'];

  return defineNorm({
    id: 'founders-first',
    label: 'Founders first',
    section: 'S16',
    establishAfter: config.normRules.establishAfter,
    decayAfter: config.normRules.decayAfter,
    reinforcedBy(ctx, entry) {
      const p = foodPrecedent(ctx, entry);
      if (p === null) return false;
      return p.short === null
        ? ranksBefore(p.order, ['founders'], ['newcomers'])
        : wentShort(p, ['newcomers'], false) && !wentShort(p, ['founders'], false);
    },
    contradictedBy(ctx, entry) {
      const p = foodPrecedent(ctx, entry);
      return p !== null && p.short !== null && wentShort(p, ['founders'], false);
    },
    modifierTargets: ['eventWeight'],
    modifiers(ctx, target) {
      if (!ctx.state.norms['founders-first'].established) return [];
      if (target.kind !== 'eventWeight' || !c.arrivalEvents.includes(target.eventId)) return [];
      return [mod.mul('norm:founders-first', c.arrivalsMul, 'word is that newcomers go short')];
    },
  });
}
